import { render } from "./ParticipantList.vue?vue&type=template&id=2b64a70d&scoped=true"
import script from "./ParticipantList.vue?vue&type=script&lang=js"
export * from "./ParticipantList.vue?vue&type=script&lang=js"

import "./ParticipantList.vue?vue&type=style&index=0&id=2b64a70d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b64a70d"]])

export default __exports__